//Add screenshot limit
export const ADD_SCREENSHOT_LIMIT_REQUEST = "ADD_SCREENSHOT_LIMIT_REQUEST";
export const ADD_SCREENSHOT_LIMIT_SUCCESS = "ADD_SCREENSHOT_LIMIT_SUCCESS";
export const ADD_SCREENSHOT_LIMIT_FAIL = "ADD_SCREENSHOT_LIMIT_FAIL";

//Add Idle Time limit
export const ADD_IDLE_TIME_LIMIT_REQUEST = "ADD_IDLE_TIME_LIMIT_REQUEST";
export const ADD_IDLE_TIME_LIMIT_SUCCESS = "ADD_IDLE_TIME_LIMIT_SUCCESS";
export const ADD_IDLE_TIME_LIMIT_FAIL = "ADD_IDLE_TIME_LIMIT_FAIL";

//Add Idle On Or Off
export const ADD_IDLE_REQUEST = "ADD_IDLE_REQUEST";
export const ADD_IDLE_SUCCESS = "ADD_IDLE_SUCCESS";
export const ADD_IDLE_FAIL = "ADD_IDLE_FAIL";

//Add Weekly limit
export const ADD_WEEKLY_LIMIT_REQUEST = "ADD_WEEKLY_LIMIT_REQUEST";
export const ADD_WEEKLY_LIMIT_SUCCESS = "ADD_WEEKLY_LIMIT_SUCCESS";
export const ADD_WEEKLY_LIMIT_FAIL = "ADD_WEEKLY_LIMIT_FAIL";

//Add Notification
export const ADD_NOTIFICATION_REQUEST = "ADD_NOTIFICATION_REQUEST";
export const ADD_NOTIFICATION_SUCCESS = "ADD_NOTIFICATION_SUCCESS";
export const ADD_NOTIFICATION_FAIL = "ADD_NOTIFICATION_FAIL";

//Add Time Hero
export const ADD_TIMEHERO_REQUEST = "ADD_TIMEHERO_REQUEST";
export const ADD_TIMEHERO_SUCCESS = "ADD_TIMEHERO_SUCCESS";
export const ADD_TIMEHERO_FAIL = "ADD_NOTIFICATION_FAIL";

//Get Data of User Setting By Company
export const GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST =
  "GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST";
export const GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS =
  "GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS";
export const GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL =
  "GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL";

//Get Data of User Setting By Department
export const GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_REQUEST =
  "GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_REQUEST";
export const GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_SUCCESS =
  "GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_SUCCESS";
export const GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_FAIL =
  "GET_DATA_Of_USER_SETTING_BY_DEPARTMENT_FAIL";

//Add Company Setting
export const ADD_COMPANY_SETTING_REQUEST = "ADD_COMPANY_SETTING_REQUEST";
export const ADD_COMPANY_SETTING_SUCCESS = "ADD_COMPANY_SETTING_SUCCESS";
export const ADD_COMPANY_SETTING_FAIL = "ADD_COMPANY_SETTING_FAIL";

//ADD_ALL_COMPANY_USERS_IDLE_TIME
export const ADD_ALL_COMPANY_USERS_IDLE_TIME_REQUEST =
  "ADD_ALL_COMPANY_USERS_IDLE_TIME_REQUEST";
export const ADD_ALL_COMPANY_USERS_IDLE_TIME_SUCCESS =
  "ADD_ALL_COMPANY_USERS_IDLE_TIME_SUCCESS";
export const ADD_ALL_COMPANY_USERS_IDLE_TIME_FAIL =
  "ADD_ALL_COMPANY_USERS_IDLE_TIME_FAIL";

//ADD_ALL_COMPANY_USERS_SCREENSHOT
export const ADD_ALL_COMPANY_USERS_SCREENSHOT_REQUEST =
  "ADD_ALL_COMPANY_USERS_SCREENSHOT_REQUEST";
export const ADD_ALL_COMPANY_USERS_SCREENSHOT_SUCCESS =
  "ADD_ALL_COMPANY_USERS_SCREENSHOT_SUCCESS";
export const ADD_ALL_COMPANY_USERS_SCREENSHOT_FAIL =
  "ADD_ALL_COMPANY_USERS_SCREENSHOT_FAIL";

//ADD_ALL_COMPANY_WEEKLY_LIMIT
export const ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_REQUEST =
  "ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_REQUEST";
export const ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_SUCCESS =
  "ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_SUCCESS";
export const ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_FAIL =
  "ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_FAIL";

//ADD_ALL_COMPANY_TIME_HERO
export const ADD_ALL_COMPANY_USERS_TIME_HERO_REQUEST =
  "ADD_ALL_COMPANY_USERS_TIME_HERO_REQUEST";
export const ADD_ALL_COMPANY_USERS_TIME_HERO_SUCCESS =
  "ADD_ALL_COMPANY_USERS_TIME_HERO_SUCCESS";
export const ADD_ALL_COMPANY_USERS_TIME_HERO_FAIL =
  "ADD_ALL_COMPANY_USERS_TIME_HERO_FAIL";

//GET COMPANY SETTINGS
export const GET_COMPANY_SETTING_REQUEST = "GET_COMPANY_SETTING_REQUEST";
export const GET_COMPANY_SETTING_SUCCESS = "GET_COMPANY_SETTING_SUCCESS";
export const GET_COMPANY_SETTING_FAIL = "GET_COMPANY_SETTING_FAIL";

//Add App Track IN MANAGER
export const ADD_APP_TRACK_IN_MANAGER_REQUEST =
  "ADD_APP_TRACK_IN_MANAGER_REQUEST";
export const ADD_APP_TRACK_IN_MANAGER_SUCCESS =
  "ADD_APP_TRACK_IN_MANAGER_SUCCESS";
export const ADD_APP_TRACK_IN_MANAGER_FAIL = "ADD_APP_TRACK_IN_MANAGER_FAIL";
